import { render } from "./musica.vue?vue&type=template&id=d908bad6"
import script from "./musica.vue?vue&type=script&lang=js"
export * from "./musica.vue?vue&type=script&lang=js"

import "./musica.vue?vue&type=style&index=0&id=d908bad6&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__